import { saveAs } from 'file-saver';
import JSZip from 'jszip';

export type ZipFile = {
  // Path within the archive. Use a "subdir/name.pdf" path to nest into a folder.
  name: string;
  url: string;
};

export type ZipResult = { added: number; skipped: number };

const fetchBlob = async (url: string): Promise<Blob> => {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`fetch ${res.status}`);
  return res.blob();
};

export const buildAndDownloadZip = async (
  zipName: string,
  files: ZipFile[]
): Promise<ZipResult> => {
  const zip = new JSZip();
  let added = 0;
  let skipped = 0;

  await Promise.all(
    files.map(async ({ name, url }) => {
      try {
        zip.file(name, await fetchBlob(url));
        added += 1;
      } catch {
        skipped += 1;
      }
    })
  );

  const blob = await zip.generateAsync({ type: 'blob' });
  saveAs(blob, zipName);
  return { added, skipped };
};
